import React from 'react';
import PropTypes from 'prop-types';
import 'd3';
import NVD3Chart from 'react-nvd3';
import get from 'lodash/get';

import Chart from '../../../components/Chart';

import {
  getTotalUndergraduateEnrollment,
  donutCallback,
  donutTooltip,
  formatValueAsPercent,
  formatDonutHalves,
} from '../../../utils/charts';

export function onRenderEnd(undergraduateEnrollment) {
  const totalUndergraduateEnrollment = getTotalUndergraduateEnrollment(
    undergraduateEnrollment,
  ).toFixed(0);

  donutCallback('#age-data-container', totalUndergraduateEnrollment, [
    'Total Undergrad',
    'Students',
  ]);
}

export function getAgeData(age) {
  if (age && age.value) {
    const over24 = Number(get(age, 'value', 0));
    return [100 - over24, over24];
  }
  return [];
}

export default function Age({ undergraduateEnrollment, age, isCamino }) {
  const data = formatDonutHalves(getAgeData(age), ['Under 24', 'Over 24'], isCamino);

  return (
    <Chart data={data} title="Age" id="age-data-container">
      <NVD3Chart
        id="ageData"
        type="pieChart"
        datum={data}
        x="line1"
        y="value"
        margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
        donut
        showLegend={false}
        labelType="value"
        donutRatio={0.5}
        showLabels
        showValues
        duration={250}
        labelThreshold={0.05}
        growOnHover
        renderEnd={() => onRenderEnd(undergraduateEnrollment)}
        valueFormat={formatValueAsPercent}
        tooltip={donutTooltip}
        padAngle={0.005}
      />
    </Chart>
  );
}

Age.propTypes = {
  undergraduateEnrollment: PropTypes.object,
  age: PropTypes.object,
  isCamino: PropTypes.bool,
};
